import React, { useEffect, useState } from 'react'
import { ModalService } from 'services/ModalService'
import SelectPaymentType from '@bet25/ui/SelectPaymentType'

const SelectPaymentTypeModal = ({ data }) => {
    const onClickReadMore = () => {
        ModalService.showModal('WITHDRAW_READ_MORE', data)
    }

    return (
        <SelectPaymentType
            currentTheme={'dark'}
            userData={data.userData}
            moneyAmount={data.modalData.moneyAmount}
            onCloseModal={() => {
                ModalService.closeModal('WITHDRAW_SELECT_PAYMENT')
            }}
            onClickReadMore={onClickReadMore}
            setAddBankAccStep={data.modalData.setAddBankAccStep}
            onSelectPaymentTypeAction={data.modalData.onSelectPaymentTypeAction}
        />
    )
}

export default SelectPaymentTypeModal
